import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';
import classNames from 'classnames';
import CommonButton from '../../common/components/CommonButton';
import { CommonButtonVariants } from '../../constants/CommonButtonVariants';
import SettingsSectionHeader from '../../settings/SettingsSectionHeader';
import '../../assets/css/componentStyles/PhotoGalleryGuideModal.css';

function PhotoGalleryGuideModal({
  isOpen,
  toggle,
  onClose,
  className,
  size,
  backdrop,
  keyboard,
  autoFocus,
  content,
}) {
  const handleClose = useCallback(() => {
    if (onClose) {
      onClose();
    }
    toggle();
  }, [toggle, onClose]);

  const modalClassName = classNames('photo-gallery-guide-modal', className);

  const defaultContent = {
    title: 'Photo Gallery Guide',
    description: `Egestas purus ac non facilisi pellentesque lorem dictum eget. Leo nunc dignissim
      neque viverra vitae a. Malesuada tortor penatibus habitant mauris sit mi sed.
      Sapien felis duis aliquet a blandit velit gravida. Ullamcorper ac a sit aliquam
      laoreet vitae.`,
    tips: [
      'Senectus nibh enim nam dolor.',
      'Placerat massa ultrices eget et quam felis.',
      'Risus commodo amet sit eget a.',
      'Ultrices in felis nisl arcu.',
      'Consectetur laoreet tincidunt eget vitae faucibus aliquet et at.',
      'A elementum hendrerit nulla faucibus.',
    ],
    footer: `Mus egestas feugiat magna lacinia sed netus in pretium pellentesque. Mauris et
      dictum felis turpis.`,
  };

  const modalContent = content || defaultContent;

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size={size}
      backdrop={backdrop}
      keyboard={keyboard}
      autoFocus={autoFocus}
      backdropClassName="photo-gallery-guide-modal-backdrop"
      className={modalClassName}
      aria-labelledby="photo-gallery-guide-title"
      aria-describedby="photo-gallery-guide-description"
    >
      <ModalHeader toggle={toggle} tag="div">
        <SettingsSectionHeader
          id="photo-gallery-guide-title"
          header={modalContent.title}
          variant="secondary"
        />
      </ModalHeader>
      <ModalBody>
        <div className="guide-content" role="main">
          <div id="photo-gallery-guide-description">
            <p className="guide-description">{modalContent.description}</p>
          </div>
          {modalContent.tips && modalContent.tips.length > 0 && (
            <ul className="guide-tips">
              {modalContent.tips.map((tip) => (
                <li key={tip} className="guide-tip">
                  {tip}
                </li>
              ))}
            </ul>
          )}
          {modalContent.footer && <p className="guide-footer">{modalContent.footer}</p>}
        </div>
      </ModalBody>
      <div className="modal-footer-custom">
        <Row className="mt-4 mb-3">
          <Col md={12} className="d-flex justify-content-center">
            <CommonButton
              label="CLOSE"
              variant={CommonButtonVariants.OUTLINED_RED}
              handleClick={handleClose}
              className="w-50"
              autoFocus={autoFocus}
              aria-label="Close photo gallery guide"
            />
          </Col>
        </Row>
      </div>
    </Modal>
  );
}

PhotoGalleryGuideModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg', 'xl']),
  backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['static'])]),
  keyboard: PropTypes.bool,
  autoFocus: PropTypes.bool,
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    tips: PropTypes.arrayOf(PropTypes.string),
    footer: PropTypes.string,
  }),
};

PhotoGalleryGuideModal.defaultProps = {
  onClose: null,
  className: '',
  size: 'lg',
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  content: null,
};

export default PhotoGalleryGuideModal;
